import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker-shadow",
  "use": "spr-marker-shadow-usage",
  "viewBox": "0 0 22 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 6\" id=\"spr-marker-shadow\"><defs><path id=\"spr-marker-shadow_a\" d=\"M736 328c6.07 0 11-1.34 11-3s-4.93-3-11-3c-6.08 0-11 1.34-11 3s4.92 3 11 3\" /></defs><use fill=\"#0a1217\" xlink:href=\"#spr-marker-shadow_a\" opacity=\".3\" transform=\"translate(-725 -322)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker-shadow.svg
// module id = 270
// module chunks = 0